<template lang="pug">
  main.preview#main
    .hero
      .hero-text-wrapper
        h1 Loading the Prismic's Preview...
    section
</template>

<script>
export default {
  name: 'Preview',
  beforeCreate () {
    const previewToken = this.$route.query.token

    this.$prismic.client.previewSession(previewToken, this.$prismic.linkResolver, '/')
      .then((url) => {
        window.location.replace(url)
      })
  }
}
</script>

<style lang="stylus">
.preview
  .hero
    .hero-text
      h1
        font-weight normal
  section
    height 10vh
</style>
